import Vue from 'vue';
import Vuex, { MutationTree, ActionTree, GetterTree } from 'vuex';

import { ScheduleState } from '../models/store-viewmodel';
import { Event } from '../models/events-viewmodels';
import { Config } from '../models/config-viewmodel';

import { root } from '@/shared/store';

Vue.use(Vuex);

const state: ScheduleState = {
    events: [],
    activeDate: new Date(),
    currentDate: new Date(),
    dates: [],
    weekOffset: 0,
    loading: true,
    config: {
        language: '',
        apiBasePath: '',
        userId: '',
        overviewUrl: '',
        labels: {}
    }
}

const mutations: MutationTree<ScheduleState> = {
    setEvents(state, events: Event[]) {
        state.events = events;
    },

    setWeekOffset(state, offset: number) {
        state.weekOffset = offset;
    },

    setActiveDate(state, date: Date) {
        state.activeDate = date;
    },

    setCurrentDate(state, date: Date) {
        state.currentDate = date;
    },

    setDates(state, dates: Date[]) {
        state.dates = dates;
    },

    setConfig(state, config: Config) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    }
}

const actions: ActionTree<ScheduleState, ScheduleState> = {
    getDates({state, commit}) {
        let startDate = new Date();
        let dates: Date[] = [];
        let offset = startDate.getDay() + 1 + (state.weekOffset * 7);

        for (var i = (0 - offset); i < (7 - offset); i++) {
            var date = new Date(startDate.getTime() + (i * 24 * 60 * 60 * 1000));

            // exclude weekend days
            if (!((date.getDay() == 6) || (date.getDay() == 0)))
                dates.push(date);
        }

        commit('setDates', dates);
        commit('setActiveDate', startDate);
        commit('setCurrentDate', startDate);
    },

    nextWeek({state, commit, dispatch}) {
        commit('setWeekOffset', state.weekOffset - 1);
        dispatch('getDates');
    },

    prevWeek({state, commit, dispatch}) {
        commit('setWeekOffset', state.weekOffset + 1);
        dispatch('getDates');
    },
    setActiveDate(context, activeDate: Date) {
        context.commit('setActiveDate', activeDate);
    },
    setEvents(context, events) {
        context.commit('setEvents', events);
    },
    setLoading(context, loadingState: boolean) {
        context.commit('setLoading', loadingState);
    },
    setError(context, error) {
        context.commit('root/setErrors', error);
    },
    clearErrors(context) {
        context.commit('root/clearErrors');
    },
    setConfig(context, config) {
        context.commit('setConfig', config);
    }
}

const getters: GetterTree<ScheduleState, ScheduleState> = {
    config(state) {
        return state.config;
    },

    loading(state) {
        return state.loading;
    },

    dates(state) {
        return state.dates;
    },

    events(state) {
        return state.events;
    },

    currentDate(state) {
        return state.currentDate;
    },

    activeDate(state) {
        return state.activeDate;
    },

    weekOffset(state) {
        return state.weekOffset;
    }
}

export default new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
    modules: {
        root
    }
})
